
import React, { useState, useEffect } from 'react';
import '../assets/styles/CadastroProdutor.css';
import '../assets/styles/TabelaResultados.css';

// Popup de edição genérico
function EditarPopup({ aberto, onClose, onSalvar, dados, campos }) {
  // Para usuários com campos de senha, não filtrar os dados iniciais
  const temCampoSenha = campos.some(campo => campo.nome === 'senha');
  const dadosIniciais = dados && !temCampoSenha ? limparCamposData(dados) : (dados || {});
  
  const [form, setForm] = useState(dadosIniciais);
  useEffect(() => { 
    const dadosParaForm = dados && !temCampoSenha ? limparCamposData(dados) : (dados || {});
    setForm(dadosParaForm); 
  }, [dados, temCampoSenha]);
  if (!aberto) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0008', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{ background: '#fff', borderRadius: 10, padding: 28, minWidth: 320, maxWidth: 400, boxShadow: '0 4px 24px #0002', position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 8, right: 12, background: 'none', border: 'none', fontSize: 22, color: '#888', cursor: 'pointer' }}>×</button>
        <h3 style={{ margin: 0, marginBottom: 18, fontWeight: 700, fontSize: 20 }}>Editar Dados</h3>
        <form onSubmit={e => { e.preventDefault(); onSalvar(form); }} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* Campo id somente leitura, se existir */}
          {'id' in form && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <label style={{ fontWeight: 500 }}>ID</label>
              <input type="text" value={form.id} readOnly style={{ padding: 8, borderRadius: 5, border: '1.5px solid #bdbdbd', fontSize: 15, background: '#f5f5f5', color: '#888' }} />
            </div>
          )}
          {campos.map(campo => (
            <div key={campo.nome} style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <label style={{ fontWeight: 500 }}>{campo.label}</label>
              {campo.tipo === 'select' ? (
                <select
                  value={form[campo.nome] ?? ''}
                  onChange={e => setForm(f => ({ ...f, [campo.nome]: e.target.value }))}
                  style={{ padding: 8, borderRadius: 5, border: '1.5px solid #bdbdbd', fontSize: 15 }}
                  required={campo.required}
                  disabled={campo.disabled}
                >
                  <option value="">Selecione...</option>
                  {campo.opcoes?.map(opcao => (
                    <option key={opcao.valor} value={opcao.valor}>{opcao.label}</option>
                  ))}
                </select>
              ) : (
                <input
                  type={campo.tipo || 'text'}
                  value={form[campo.nome] ?? ''}
                  onChange={e => setForm(f => ({ ...f, [campo.nome]: e.target.value }))}
                  style={{ padding: 8, borderRadius: 5, border: '1.5px solid #bdbdbd', fontSize: 15 }}
                  required={campo.required}
                  disabled={campo.disabled}
                />
              )}
            </div>
          ))}
          <button type="submit" style={{ marginTop: 10, background: '#3d8c5e', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 0', fontWeight: 700, fontSize: 16, cursor: 'pointer' }}>Salvar</button>
        </form>
      </div>
    </div>
  );
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Função para remover todos os campos de data do payload
const limparCamposData = (payload) => {
  console.log('=== LIMPEZA DE CAMPOS DE DATA ===');
  console.log('Payload original:', payload);
  
  if (!payload) {
    console.log('Payload é null/undefined, retornando objeto vazio');
    return {};
  }
  
  const payloadLimpo = { ...payload };
  
  // Lista específica de campos que devem ser REMOVIDOS
  const camposProibidos = [
    'data_cadastro', 'created_at', 'updated_at', 'data_criacao', 'data_atualizacao',
    'date_created', 'date_updated', 'timestamp', 'created', 'updated',
    'password'
    // Nota: 'senha', 'confirmarSenha' e 'senha_hash' são tratados especialmente
  ];
  
  // Remover campos específicos da lista proibida
  camposProibidos.forEach(campo => {
    if (payloadLimpo.hasOwnProperty(campo)) {
      console.log(`❌ REMOVIDO campo proibido: ${campo} = ${payloadLimpo[campo]}`);
      delete payloadLimpo[campo];
    }
  });
  
  // Remover qualquer campo que contenha padrões de data (proteção extra)
  Object.keys(payloadLimpo).forEach(campo => {
    const campoLower = campo.toLowerCase();
    if (campoLower.includes('data_') && campoLower !== 'quantidade_produzida') {
      console.log(`❌ REMOVIDO campo com padrão de data: ${campo} = ${payloadLimpo[campo]}`);
      delete payloadLimpo[campo];
    } else if (campoLower.includes('_at')) {
      console.log(`❌ REMOVIDO campo timestamp: ${campo} = ${payloadLimpo[campo]}`);
      delete payloadLimpo[campo];
    } else {
      console.log(`✅ MANTIDO campo: ${campo} = ${payloadLimpo[campo]}`);
    }
  });
  
  console.log('Payload limpo final:', payloadLimpo);
  console.log('=== FIM DA LIMPEZA ===');
  
  return payloadLimpo;
};

// Função para filtrar campos que não devem aparecer na interface de edição
const filtrarCamposEdicao = (campos) => {
  const camposProibidos = [
    'id', 'data_cadastro', 'created_at', 'updated_at', 'data_criacao', 'data_atualizacao',
    'date_created', 'date_updated', 'timestamp', 'created', 'updated'
  ];
  
  return campos.filter(campo => {
    // Verifica se o campo está na lista de proibidos
    if (camposProibidos.includes(campo.nome)) {
      return false;
    }
    // Verifica se o campo contém padrões de data
    if (campo.nome.toLowerCase().includes('data_') || 
        campo.nome.toLowerCase().includes('_at') ||
        campo.nome.toLowerCase().includes('timestamp')) {
      return false;
    }
    return true;
  });
};

export default function Consultar() {
  // Estado para popup de edição
  const [popupAberto, setPopupAberto] = useState(false);
  const [itemEditando, setItemEditando] = useState(null);
  const [dados, setDados] = useState({
    familias: [],
    povoados: [],
    regioes: [],
    culturas: [],
    producoes: [],
    usuarios: []
  });
  const [filtros, setFiltros] = useState({
    tipoConsulta: 'familias',
    busca: ''
  });
  // resultados: { tipo: string, dados: array }
  const [resultados, setResultados] = useState({ tipo: 'familias', dados: [] });
  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState(null);
  // Paginação
  const [pagina, setPagina] = useState(1);
  const itensPorPagina = 12;
  const totalPaginas = Math.ceil(resultados.dados.length / itensPorPagina) || 1;

  // Carregar dados iniciais
  useEffect(() => {
    const carregarDados = async () => {
      setCarregando(true);
      try {
        const [familiasRes, povoadosRes, regioesRes, culturasRes, producoesRes, usuariosRes] = await Promise.all([
          fetch(`${API_BASE_URL}/familias/`),
          fetch(`${API_BASE_URL}/povoados/`),
          fetch(`${API_BASE_URL}/regioes/`),
          fetch(`${API_BASE_URL}/culturas/`),
          fetch(`${API_BASE_URL}/producao_familia/`),
          fetch(`${API_BASE_URL}/usuarios/`)
        ]);

        const [familias, povoados, regioes, culturas, producoes, usuarios] = await Promise.all([
          familiasRes.json(),
          povoadosRes.json(),
          regioesRes.json(),
          culturasRes.json(),
          producoesRes.json(),
          usuariosRes.json()
        ]);

        setDados({
          familias: Array.isArray(familias.productId) ? familias.productId : [],
          povoados: Array.isArray(povoados.productId) ? povoados.productId : [],
          regioes: Array.isArray(regioes.productId) ? regioes.productId : [],
          culturas: Array.isArray(culturas.productId) ? culturas.productId : [],
          producoes: Array.isArray(producoes.productId) ? producoes.productId : [],
          usuarios: Array.isArray(usuarios.productId) ? usuarios.productId : []
        });

        console.log('Dados carregados:', { familias, povoados, regioes, culturas, producoes, usuarios });
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        setMensagem('❌ Erro ao carregar dados iniciais.');
      } finally {
        setCarregando(false);
      }
    };

    carregarDados();
  }, []);

  // Funções utilitárias simplificadas
  const getNomeRegiao = (regiao_id) => {
    const regiao = dados.regioes.find(r => r.id === regiao_id);
    return regiao ? regiao.nome : 'N/A';
  };
  const getNomePovoado = (povoado_id) => {
    const povoado = dados.povoados.find(p => p.id === povoado_id);
    return povoado ? povoado.nome : 'N/A';
  };
  const getNomeCultura = (cultura_id) => {
    const cultura = dados.culturas.find(c => c.id === cultura_id);
    return cultura ? cultura.nome : 'N/A';
  };
  const getNomeFamilia = (familia_id) => {
    const familia = dados.familias.find(f => f.id === familia_id);
    return familia ? familia.nome_responsavel : 'N/A';
  };


  // Só altera o filtro, não executa busca automaticamente nem limpa resultados
  const handleFiltroChange = (e) => {
    setFiltros(prev => ({ ...prev, [e.target.name]: e.target.value }));
    // Não altera resultados nem mensagem!
  };

  // Pesquisa global apenas por nome ou id
  const filtrarPorBusca = (arr) => {
    if (!filtros.busca.trim()) return arr;
    const termo = filtros.busca.trim().toLowerCase();
    return arr.filter(item => {
      // Tenta encontrar campos de nome e id
      let nome = item.nome || item.nome_responsavel || item.nome_cultura || '';
      let id = item.id || item.cultura_id || '';
      return (
        nome.toString().toLowerCase().includes(termo) ||
        id.toString().toLowerCase().includes(termo)
      );
    });
  };

  const aplicarFiltros = () => {
    setCarregando(true);
    setMensagem(null);
    setPagina(1); // Sempre volta para a primeira página ao filtrar

    let dadosFiltrados = [];

    switch (filtros.tipoConsulta) {
      case 'familias':
        dadosFiltrados = filtrarPorBusca(dados.familias);
        break;
      case 'povoados':
        dadosFiltrados = filtrarPorBusca(dados.povoados);
        break;
      case 'producoes':
        dadosFiltrados = filtrarPorBusca(dados.producoes);
        break;
      case 'usuarios':
        dadosFiltrados = filtrarPorBusca(dados.usuarios);
        break;
      case 'regioes':
        dadosFiltrados = filtrarPorBusca(dados.regioes);
        break;
      case 'culturas':
        // Agrupar produções por cultura para calcular estatísticas
        const culturaStats = {};
        dados.producoes.forEach(producao => {
          const culturaId = producao.cultura_id;
          if (!culturaStats[culturaId]) {
            culturaStats[culturaId] = {
              cultura_id: culturaId,
              total_producoes: 0,
              quantidade_total: 0,
              familias_produtoras: new Set(),
              anos: new Set()
            };
          }
          culturaStats[culturaId].total_producoes++;
          culturaStats[culturaId].quantidade_total += parseFloat(producao.quantidade_produzida || 0);
          culturaStats[culturaId].familias_produtoras.add(producao.familia_id);
          culturaStats[culturaId].anos.add(producao.ano);
        });
        // Converter para array e adicionar informações da cultura
        let culturasArr = Object.values(culturaStats).map(stat => {
          const cultura = dados.culturas.find(c => c.id === stat.cultura_id);
          return {
            ...stat,
            nome_cultura: cultura ? cultura.nome : 'Cultura não encontrada',
            num_familias: stat.familias_produtoras.size,
            anos_producao: Array.from(stat.anos).sort().join(', '),
            anos_set: stat.anos // Manter o Set para filtragem
          };
        });
        dadosFiltrados = filtrarPorBusca(culturasArr);
        break;
      default:
        dadosFiltrados = [];
    }

    setResultados({ tipo: filtros.tipoConsulta, dados: dadosFiltrados });
    setCarregando(false);
    if (dadosFiltrados.length === 0) {
      setMensagem('ℹ️ Nenhum resultado encontrado.');
    } else {
      setMensagem(`✅ ${dadosFiltrados.length} registro(s) encontrado(s).`);
    }
  };

  const limparFiltros = () => {
    setFiltros({
      tipoConsulta: 'familias',
      busca: ''
    });
    setResultados({ tipo: 'familias', dados: [] });
    setMensagem(null);
    setPagina(1);
  };

  // Paginação dos resultados
  const paginar = (arr) => arr.slice((pagina - 1) * itensPorPagina, pagina * itensPorPagina);

  // Sempre renderiza a tabela do tipo salvo em resultados.tipo
  const renderTabela = () => {
    if (resultados.dados.length === 0) {
      return (
        <div style={{ width: '100%', textAlign: 'center', color: '#888', fontSize: 18, padding: '40px 0' }}>
          <span>ℹ️ Nenhum dado encontrado.</span>
        </div>
      );
    }
    const paginados = paginar(resultados.dados);
    switch (resultados.tipo) {
      case 'familias':
        return (
          <>
            <table style={{width: '100%', borderCollapse: 'collapse'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Responsável</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Povoado</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Região</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Tipo Produção</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Coordenadas</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {paginados.map(familia => {
                  const povoado = dados.povoados.find(p => p.id === familia.povoado_id);
                  return (
                    <tr key={familia.id}>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{familia.nome_responsavel}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{getNomePovoado(familia.povoado_id)}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{povoado ? getNomeRegiao(povoado.regiao_id) : 'N/A'}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{familia.tipo_producao}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                        {familia.latitude && familia.longitude ? `${familia.latitude}, ${familia.longitude}` : 'N/A'}
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0', minWidth: 120 }}>
                        <button onClick={() => { setItemEditando(familia); setPopupAberto(true); }} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', marginRight: 6, cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                        <button onClick={async () => { 
                          if(window.confirm('Tem certeza que deseja excluir esta família?')) {
                            try {
                              const resp = await fetch(`${API_BASE_URL}/familias/delete`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ id: familia.id })
                              });
                              if (!resp.ok) throw new Error('Erro ao excluir');
                              // Remove localmente
                              setDados(prev => ({
                                ...prev,
                                familias: prev.familias.filter(f => f.id !== familia.id)
                              }));
                              // Atualiza a tabela se estiver mostrando famílias
                              if (resultados.tipo === 'familias') {
                                setResultados(prev => ({
                                  ...prev,
                                  dados: prev.dados.filter(f => f.id !== familia.id)
                                }));
                              }
                              setMensagem('✅ Família excluída com sucesso!');
                            } catch (e) {
                              setMensagem('❌ Erro ao excluir família: ' + e.message);
                            }
                          }
                        }} style={{ background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', cursor: 'pointer', fontWeight: 600 }}>Excluir</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <EditarPopup
              aberto={popupAberto}
              onClose={() => setPopupAberto(false)}
              dados={itemEditando}
              onSalvar={async form => {
                // Atualizar no banco (POST /api/familias/update)
                try {
                  const id = form.id;
                  let payload = limparCamposData(form);
                  
                  // Debug: verificar payload final
                  console.log('=== SALVAMENTO ===');
                  console.log('Form original:', form);
                  console.log('Payload final a ser enviado:', payload);
                  
                  // Verificação de segurança: bloquear se algum campo de data passar
                  const camposDataEncontrados = Object.keys(payload).filter(key => 
                    (key.toLowerCase().includes('data_') && key !== 'quantidade_produzida') ||
                    key.toLowerCase().includes('_at') ||
                    key.toLowerCase().includes('timestamp') ||
                    ['created', 'updated', 'senha_hash'].includes(key.toLowerCase())
                  );
                  
                  if (camposDataEncontrados.length > 0) {
                    console.error('ERRO: Campos protegidos detectados!', camposDataEncontrados);
                    setMensagem(`❌ Erro: Campos protegidos detectados: ${camposDataEncontrados.join(', ')}`);
                    return;
                  }
                  
                  // id deve estar no corpo
                  // Usar a mesma rota que funciona no CadastroFamilia.jsx
                  const resp = await fetch(`${API_BASE_URL}/familias/update`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                  });
                  if (!resp.ok) throw new Error('Erro ao atualizar');
                  // Atualiza localmente
                  setDados(prev => ({
                    ...prev,
                    familias: prev.familias.map(f => f.id === id ? { ...f, ...payload } : f)
                  }));
                  setPopupAberto(false);
                  setMensagem('✅ Dados atualizados com sucesso!');
                } catch (e) {
                  setMensagem('❌ Erro ao atualizar família: ' + e.message);
                }
              }}
              campos={filtrarCamposEdicao([
                { nome: 'nome_responsavel', label: 'Responsável', required: true },
                { nome: 'povoado_id', label: 'Povoado (ID)', required: true },
                { nome: 'tipo_producao', label: 'Tipo Produção' },
                { nome: 'latitude', label: 'Latitude' },
                { nome: 'longitude', label: 'Longitude' },
                // Não incluir id nem datas de cadastro
              ])}
            />
          </>
        );

      case 'povoados':
        return (
          <>
            <table style={{width: '100%', borderCollapse: 'collapse'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Nome</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Região</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Coordenadas</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Nº Famílias</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
        {paginados.map(povoado => {
                  const numFamilias = dados.familias.filter(f => f.povoado_id === povoado.id).length;
                  return (
                    <tr key={povoado.id}>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{povoado.nome}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{getNomeRegiao(povoado.regiao_id)}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                        {povoado.latitude && povoado.longitude ? `${povoado.latitude}, ${povoado.longitude}` : 'N/A'}
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>{numFamilias}</td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0', minWidth: 120 }}>
                        <button onClick={() => { setItemEditando(povoado); setPopupAberto(true); }} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', marginRight: 6, cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                        <button onClick={async () => { 
                          if(window.confirm('Tem certeza que deseja excluir este povoado?')) {
                            try {
                              const resp = await fetch(`${API_BASE_URL}/povoados/delete`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ id: povoado.id })
                              });
                              if (!resp.ok) throw new Error('Erro ao excluir');
                              setDados(prev => ({
                                ...prev,
                                povoados: prev.povoados.filter(p => p.id !== povoado.id)
                              }));
                              if (resultados.tipo === 'povoados') {
                                setResultados(prev => ({
                                  ...prev,
                                  dados: prev.dados.filter(p => p.id !== povoado.id)
                                }));
                              }
                              setMensagem('✅ Povoado excluído com sucesso!');
                            } catch (e) {
                              setMensagem('❌ Erro ao excluir povoado: ' + e.message);
                            }
                          }
                        }} style={{ background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', cursor: 'pointer', fontWeight: 600 }}>Excluir</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {resultados.tipo === 'povoados' && (
              <EditarPopup
                aberto={popupAberto}
                onClose={() => setPopupAberto(false)}
                dados={itemEditando}
                onSalvar={async form => {
                  try {
                    const id = form.id;
                    const payload = limparCamposData(form);
                    
                    // Debug: verificar se dados de cadastro estão sendo removidos
                    console.log('Povoado - Dados originais:', form);
                    console.log('Povoado - Payload após limpeza:', payload);
                    
                    // Verificação adicional: garantir que não há campos de data
                    if (payload.data_cadastro || payload.created_at || payload.updated_at) {
                      console.error('ERRO: Campos de data ainda presentes no payload!', payload);
                      setMensagem('❌ Erro: Tentativa de alterar campos protegidos detectada!');
                      return;
                    }
                    
                    const resp = await fetch(`${API_BASE_URL}/povoados/update`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(payload)
                    });
                    if (!resp.ok) throw new Error('Erro ao atualizar');
                    setDados(prev => ({
                      ...prev,
                      povoados: prev.povoados.map(p => p.id === id ? { ...p, ...payload } : p)
                    }));
                    setPopupAberto(false);
                    setMensagem('✅ Dados atualizados com sucesso!');
                  } catch (e) {
                    setMensagem('❌ Erro ao atualizar povoado: ' + e.message);
                  }
                }}
                campos={filtrarCamposEdicao([
                  { nome: 'nome', label: 'Nome', required: true },
                  { nome: 'regiao_id', label: 'Região (ID)', required: true },
                  { nome: 'latitude', label: 'Latitude' },
                  { nome: 'longitude', label: 'Longitude' },
                ])}
              />
            )}
          </>
        );

      case 'producoes':
        return (
          <>
            <table style={{width: '100%', borderCollapse: 'collapse'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Família</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Cultura</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ano</th>
                  <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #e2e8f0' }}>Quantidade</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Unidade</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Povoado</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
        {paginados.map(producao => (
                  <tr key={producao.id}>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{getNomeFamilia(producao.familia_id)}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{getNomeCultura(producao.cultura_id)}</td>
                    <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>{producao.ano}</td>
                    <td style={{ padding: '12px', textAlign: 'right', borderBottom: '1px solid #e2e8f0' }}>{producao.quantidade_produzida}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{producao.unidade}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                      {(() => {
                        const familia = dados.familias.find(f => f.id === producao.familia_id);
                        return familia ? getNomePovoado(familia.povoado_id) : 'N/A';
                      })()}
                    </td>
                    <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0', minWidth: 120 }}>
                      <button onClick={() => { setItemEditando(producao); setPopupAberto(true); }} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', marginRight: 6, cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                      <button onClick={async () => { 
                        if(window.confirm('Tem certeza que deseja excluir esta produção?')) {
                          try {
                            const resp = await fetch(`${API_BASE_URL}/producao_familia/delete`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: producao.id })
                            });
                            if (!resp.ok) throw new Error('Erro ao excluir');
                            setDados(prev => ({
                              ...prev,
                              producoes: prev.producoes.filter(p => p.id !== producao.id)
                            }));
                            if (resultados.tipo === 'producoes') {
                              setResultados(prev => ({
                                ...prev,
                                dados: prev.dados.filter(p => p.id !== producao.id)
                              }));
                            }
                            setMensagem('✅ Produção excluída com sucesso!');
                          } catch (e) {
                            setMensagem('❌ Erro ao excluir produção: ' + e.message);
                          }
                        }
                      }} style={{ background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', cursor: 'pointer', fontWeight: 600 }}>Excluir</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {resultados.tipo === 'producoes' && (
              <EditarPopup
                aberto={popupAberto}
                onClose={() => setPopupAberto(false)}
                dados={itemEditando}
                onSalvar={async form => {
                  try {
                    const id = form.id;
                    const payload = limparCamposData(form);
                    
                    // Debug: verificar se dados de cadastro estão sendo removidos
                    console.log('Produção - Dados originais:', form);
                    console.log('Produção - Payload após limpeza:', payload);
                    
                    // Verificação adicional: garantir que não há campos de data
                    if (payload.data_cadastro || payload.created_at || payload.updated_at) {
                      console.error('ERRO: Campos de data ainda presentes no payload!', payload);
                      setMensagem('❌ Erro: Tentativa de alterar campos protegidos detectada!');
                      return;
                    }
                    
                    const resp = await fetch(`${API_BASE_URL}/producao_familia/update`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(payload)
                    });
                    if (!resp.ok) throw new Error('Erro ao atualizar');
                    setDados(prev => ({
                      ...prev,
                      producoes: prev.producoes.map(p => p.id === id ? { ...p, ...payload } : p)
                    }));
                    setPopupAberto(false);
                    setMensagem('✅ Dados atualizados com sucesso!');
                  } catch (e) {
                    setMensagem('❌ Erro ao atualizar produção: ' + e.message);
                  }
                }}
                campos={filtrarCamposEdicao([
                  { nome: 'familia_id', label: 'Família (ID)', required: true },
                  { nome: 'cultura_id', label: 'Cultura (ID)', required: true },
                  { nome: 'ano', label: 'Ano', required: true },
                  { nome: 'quantidade_produzida', label: 'Quantidade Produzida', required: true },
                  { nome: 'unidade', label: 'Unidade', required: true },
                ])}
              />
            )}
          </>
        );

      case 'usuarios':
        return (
          <>
            <table style={{width: '100%', borderCollapse: 'collapse'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Nome</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Email</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Perfil</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ativo</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
        {paginados.map(usuario => (
                  <tr key={usuario.id}>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{usuario.nome}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{usuario.email}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{usuario.perfil}</td>
                    <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>{usuario.ativo === 's' ? 'Sim' : 'Não'}</td>
                    <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0', minWidth: 120 }}>
                      <button onClick={() => { setItemEditando(usuario); setPopupAberto(true); }} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', marginRight: 6, cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                      <button onClick={async () => { 
                        if(window.confirm('Tem certeza que deseja excluir este usuário?')) {
                          try {
                            const resp = await fetch(`${API_BASE_URL}/usuarios/delete`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: usuario.id })
                            });
                            if (!resp.ok) throw new Error('Erro ao excluir');
                            setDados(prev => ({
                              ...prev,
                              usuarios: prev.usuarios.filter(u => u.id !== usuario.id)
                            }));
                            if (resultados.tipo === 'usuarios') {
                              setResultados(prev => ({
                                ...prev,
                                dados: prev.dados.filter(u => u.id !== usuario.id)
                              }));
                            }
                            setMensagem('✅ Usuário excluído com sucesso!');
                          } catch (e) {
                            setMensagem('❌ Erro ao excluir usuário: ' + e.message);
                          }
                        }
                      }} style={{ background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', cursor: 'pointer', fontWeight: 600 }}>Excluir</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {resultados.tipo === 'usuarios' && (
              <EditarPopup
                aberto={popupAberto}
                onClose={() => setPopupAberto(false)}
                dados={itemEditando}
                onSalvar={async form => {
                  try {
                    const id = form.id;
                    
                    // Validação especial para senhas em usuários
                    if (form.senha || form.confirmarSenha) {
                      if (form.senha !== form.confirmarSenha) {
                        setMensagem('❌ Erro: As senhas não coincidem!');
                        return;
                      }
                      if (form.senha && form.senha.length < 6) {
                        setMensagem('❌ Erro: A senha deve ter pelo menos 6 caracteres!');
                        return;
                      }
                    }
                    
                    let payload = limparCamposData(form);
                    
                    // Se não tem senha nova ou está vazia, remover campos de senha do payload
                    if (!form.senha || form.senha.trim() === '') {
                      delete payload.senha;
                      delete payload.senha_hash;
                      delete payload.confirmarSenha;
                      console.log('Senha vazia - removendo campos de senha do payload');
                    } else {
                      // Se tem senha, converter para senha_hash (nome correto no banco)
                      payload.senha_hash = form.senha;
                      delete payload.senha;
                      delete payload.confirmarSenha;
                      console.log('Nova senha definida - incluindo como senha_hash no payload');
                    }
                    
                    // Debug: verificar se dados de cadastro estão sendo removidos
                    console.log('Usuário - Dados originais:', form);
                    console.log('Usuário - Payload após limpeza:', payload);
                    
                    // Verificação adicional: garantir que não há campos de data (senha_hash é permitida)
                    if (payload.data_cadastro || payload.created_at || payload.updated_at) {
                      console.error('ERRO: Campos de data ainda presentes no payload!', payload);
                      setMensagem('❌ Erro: Tentativa de alterar campos protegidos detectada!');
                      return;
                    }
                    
                    const resp = await fetch(`${API_BASE_URL}/usuarios/update`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(payload)
                    });
                    if (!resp.ok) throw new Error('Erro ao atualizar');
                    setDados(prev => ({
                      ...prev,
                      usuarios: prev.usuarios.map(u => u.id === id ? { ...u, ...payload } : u)
                    }));
                    setPopupAberto(false);
                    setMensagem('✅ Dados atualizados com sucesso!');
                  } catch (e) {
                    setMensagem('❌ Erro ao atualizar usuário: ' + e.message);
                  }
                }}
                campos={filtrarCamposEdicao([
                  { nome: 'nome', label: 'Nome', required: true },
                  { nome: 'email', label: 'Email', tipo: 'email', required: true },
                  { nome: 'perfil', label: 'Perfil', tipo: 'select', opcoes: [
                    { valor: 'secretaria', label: 'Secretaria' },
                    { valor: 'tecnico', label: 'Técnico' },
                    { valor: 'administrador', label: 'Administrador' }
                  ], required: true },
                  { nome: 'ativo', label: 'Ativo', tipo: 'select', opcoes: [
                    { valor: 's', label: 'Sim' },
                    { valor: 'n', label: 'Não' }
                  ], required: true },
                  { nome: 'senha', label: 'Nova Senha (deixe vazio para manter atual)', tipo: 'password', required: false },
                  { nome: 'confirmarSenha', label: 'Confirmar Nova Senha', tipo: 'password', required: false },
                ])}
              />
            )}
          </>
        );

      case 'regioes':
        return (
          <>
            <table style={{width: '100%', borderCollapse: 'collapse'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Nome</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Nº Povoados</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Nº Famílias</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
        {paginados.map(regiao => {
                  const povoadosRegiao = dados.povoados.filter(p => p.regiao_id === regiao.id);
                  const familiasRegiao = dados.familias.filter(f => {
                    const povoado = dados.povoados.find(p => p.id === f.povoado_id);
                    return povoado && povoado.regiao_id === regiao.id;
                  });
                  return (
                    <tr key={regiao.id}>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{regiao.nome}</td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>{povoadosRegiao.length}</td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>{familiasRegiao.length}</td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0', minWidth: 120 }}>
                        <button onClick={() => { setItemEditando(regiao); setPopupAberto(true); }} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', marginRight: 6, cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                        <button onClick={async () => { 
                          if(window.confirm('Tem certeza que deseja excluir esta região?')) {
                            try {
                              const resp = await fetch(`${API_BASE_URL}/regioes/delete`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ id: regiao.id })
                              });
                              if (!resp.ok) throw new Error('Erro ao excluir');
                              setDados(prev => ({
                                ...prev,
                                regioes: prev.regioes.filter(r => r.id !== regiao.id)
                              }));
                              if (resultados.tipo === 'regioes') {
                                setResultados(prev => ({
                                  ...prev,
                                  dados: prev.dados.filter(r => r.id !== regiao.id)
                                }));
                              }
                              setMensagem('✅ Região excluída com sucesso!');
                            } catch (e) {
                              setMensagem('❌ Erro ao excluir região: ' + e.message);
                            }
                          }
                        }} style={{ background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', cursor: 'pointer', fontWeight: 600 }}>Excluir</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {resultados.tipo === 'regioes' && (
              <EditarPopup
                aberto={popupAberto}
                onClose={() => setPopupAberto(false)}
                dados={itemEditando}
                onSalvar={async form => {
                  try {
                    const id = form.id;
                    const payload = limparCamposData(form);
                    
                    // Debug: verificar se dados de cadastro estão sendo removidos
                    console.log('Região - Dados originais:', form);
                    console.log('Região - Payload após limpeza:', payload);
                    
                    // Verificação adicional: garantir que não há campos de data
                    if (payload.data_cadastro || payload.created_at || payload.updated_at) {
                      console.error('ERRO: Campos de data ainda presentes no payload!', payload);
                      setMensagem('❌ Erro: Tentativa de alterar campos protegidos detectada!');
                      return;
                    }
                    
                    const resp = await fetch(`${API_BASE_URL}/regioes/update`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(payload)
                    });
                    if (!resp.ok) throw new Error('Erro ao atualizar');
                    setDados(prev => ({
                      ...prev,
                      regioes: prev.regioes.map(r => r.id === id ? { ...r, ...payload } : r)
                    }));
                    setPopupAberto(false);
                    setMensagem('✅ Dados atualizados com sucesso!');
                  } catch (e) {
                    setMensagem('❌ Erro ao atualizar região: ' + e.message);
                  }
                }}
                campos={filtrarCamposEdicao([
                  { nome: 'nome', label: 'Nome', required: true },
                ])}
              />
            )}
          </>
        );

      case 'culturas':
        return (
          <>
            <table style={{width: '100%', borderCollapse: 'collapse'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Cultura</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Nº Produções</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Nº Famílias</th>
                  <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #e2e8f0' }}>Quantidade Total</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Anos de Produção</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
        {paginados.map((cultura, index) => (
                  <tr key={index}>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{cultura.nome_cultura}</td>
                    <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>{cultura.total_producoes}</td>
                    <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>{cultura.num_familias}</td>
                    <td style={{ padding: '12px', textAlign: 'right', borderBottom: '1px solid #e2e8f0' }}>{cultura.quantidade_total.toFixed(2)}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{cultura.anos_producao}</td>
                    <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0', minWidth: 120 }}>
                      <button onClick={() => { 
                        // Para culturas, editamos o registro original da cultura, não as estatísticas
                        const culturaOriginal = dados.culturas.find(c => c.id === cultura.cultura_id);
                        setItemEditando(culturaOriginal); 
                        setPopupAberto(true); 
                      }} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', marginRight: 6, cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                      <button onClick={async () => { 
                        if(window.confirm('Tem certeza que deseja excluir esta cultura?')) {
                          try {
                            const resp = await fetch(`${API_BASE_URL}/culturas/delete`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: cultura.cultura_id })
                            });
                            if (!resp.ok) throw new Error('Erro ao excluir');
                            setDados(prev => ({
                              ...prev,
                              culturas: prev.culturas.filter(c => c.id !== cultura.cultura_id)
                            }));
                            if (resultados.tipo === 'culturas') {
                              setResultados(prev => ({
                                ...prev,
                                dados: prev.dados.filter(c => c.cultura_id !== cultura.cultura_id)
                              }));
                            }
                            setMensagem('✅ Cultura excluída com sucesso!');
                          } catch (e) {
                            setMensagem('❌ Erro ao excluir cultura: ' + e.message);
                          }
                        }
                      }} style={{ background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', cursor: 'pointer', fontWeight: 600 }}>Excluir</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {resultados.tipo === 'culturas' && (
              <EditarPopup
                aberto={popupAberto}
                onClose={() => setPopupAberto(false)}
                dados={itemEditando}
                onSalvar={async form => {
                  try {
                    const id = form.id;
                    const payload = limparCamposData(form);
                    
                    // Debug: verificar se dados de cadastro estão sendo removidos
                    console.log('Cultura - Dados originais:', form);
                    console.log('Cultura - Payload após limpeza:', payload);
                    
                    // Verificação adicional: garantir que não há campos de data
                    if (payload.data_cadastro || payload.created_at || payload.updated_at) {
                      console.error('ERRO: Campos de data ainda presentes no payload!', payload);
                      setMensagem('❌ Erro: Tentativa de alterar campos protegidos detectada!');
                      return;
                    }
                    
                    const resp = await fetch(`${API_BASE_URL}/culturas/update`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(payload)
                    });
                    if (!resp.ok) throw new Error('Erro ao atualizar');
                    setDados(prev => ({
                      ...prev,
                      culturas: prev.culturas.map(c => c.id === id ? { ...c, ...payload } : c)
                    }));
                    setPopupAberto(false);
                    setMensagem('✅ Dados atualizados com sucesso!');
                  } catch (e) {
                    setMensagem('❌ Erro ao atualizar cultura: ' + e.message);
                  }
                }}
                campos={filtrarCamposEdicao([
                  { nome: 'nome', label: 'Nome', required: true },
                ])}
              />
            )}
          </>
        );

      default:
        return <p>Tipo de consulta não reconhecido.</p>;
    }
  };


  return (
    <div className="cadastro-produtor-container" style={{ padding: 0, background: '#f4f6fa', minHeight: '100vh' }}>
      {/* Título da página */}
      <div style={{ width: '100%', maxWidth: 1200, margin: '32px auto 0 auto', padding: '0 0 8px 0' }}>
        <h2 style={{ fontWeight: 700, fontSize: 26, color: '#3d3d3d', margin: 0, letterSpacing: 0.2 }}>Consulta de Dados</h2>
      </div>
      {/* Filtros principais */}
      <div style={{ width: '100%', maxWidth: 1200, margin: '0 auto', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #0001', border: '1px solid #e0e0e0', padding: '18px 20px 12px 20px' }}>
        <form onSubmit={e => { e.preventDefault(); aplicarFiltros(); }} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {/* Radio para selecionar tabela */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 18, flexWrap: 'wrap', marginBottom: 8 }}>
            <span style={{ fontWeight: 600, fontSize: 15, color: '#3d3d3d', minWidth: 160 }}>Selecionar o que deseja consultar:</span>
            <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontWeight: 500 }}>
                <input type="radio" name="tipoConsulta" value="familias" checked={filtros.tipoConsulta === 'familias'} onChange={handleFiltroChange} /> Famílias
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontWeight: 500 }}>
                <input type="radio" name="tipoConsulta" value="povoados" checked={filtros.tipoConsulta === 'povoados'} onChange={handleFiltroChange} /> Povoados
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontWeight: 500 }}>
                <input type="radio" name="tipoConsulta" value="producoes" checked={filtros.tipoConsulta === 'producoes'} onChange={handleFiltroChange} /> Produções
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontWeight: 500 }}>
                <input type="radio" name="tipoConsulta" value="usuarios" checked={filtros.tipoConsulta === 'usuarios'} onChange={handleFiltroChange} /> Usuários
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontWeight: 500 }}>
                <input type="radio" name="tipoConsulta" value="regioes" checked={filtros.tipoConsulta === 'regioes'} onChange={handleFiltroChange} /> Regiões
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontWeight: 500 }}>
                <input type="radio" name="tipoConsulta" value="culturas" checked={filtros.tipoConsulta === 'culturas'} onChange={handleFiltroChange} /> Culturas
              </label>
            </div>
          </div>
          {/* Barra de pesquisa ocupando toda a largura */}
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label htmlFor="busca" style={{ fontWeight: 500, fontSize: 14, color: '#3d3d3d' }}>Pesquisar</label>
            <input
              id="busca"
              name="busca"
              type="text"
              value={filtros.busca}
              onChange={handleFiltroChange}
              placeholder="Digite para pesquisar por nome, ID, etc."
              style={{ width: '100%', padding: 12, borderRadius: 6, border: '1.5px solid #bdbdbd', background: '#fafbfc', fontSize: 16 }}
            />
          </div>
          {/* Botões */}
          <div style={{ display: 'flex', gap: 10, marginTop: 6 }}>
            <button
              type="submit"
              className="btn-cadastrar"
              disabled={carregando}
              style={{ fontWeight: 700, fontSize: 15, borderRadius: 6, background: '#3d8c5e', color: '#fff', border: 'none', padding: '8px 24px', transition: 'background 0.2s', boxShadow: '0 1px 4px #0001', cursor: 'pointer', letterSpacing: 0.5 }}
            >
              {carregando ? 'Consultando...' : 'Exibir'}
            </button>
            <button
              type="button"
              onClick={limparFiltros}
              className="btn-cadastrar"
              style={{ background: '#bdbdbd', color: '#fff', fontWeight: 700, fontSize: 15, borderRadius: 6, border: 'none', padding: '8px 24px', transition: 'background 0.2s', boxShadow: '0 1px 4px #0001', cursor: 'pointer', letterSpacing: 0.5 }}
            >
              Limpar
            </button>
          </div>
        </form>
      </div>
      {/* Resultados: tabela sempre visível */}
      <div style={{ width: '100%', maxWidth: 1200, margin: '18px auto 0 auto', background: '#fff', borderRadius: 10, border: '1px solid #e0e0e0', padding: 18, boxShadow: '0 2px 8px #0001', minHeight: 350 }}>
        {/* Mensagem de feedback */}
        {mensagem && (
          <div style={{ marginBottom: 16, padding: 12, borderRadius: 6, background: mensagem.includes('❌') ? '#ffebee' : mensagem.includes('ℹ️') ? '#e3f2fd' : '#e8f5e8', color: mensagem.includes('❌') ? '#d32f2f' : mensagem.includes('ℹ️') ? '#1976d2' : '#388e3c', fontWeight: 500 }}>
            {mensagem}
          </div>
        )}
        <div style={{ width: '100%', overflowX: 'auto' }}>
          {renderTabela()}
        </div>
        {/* Paginação */}
        {resultados.dados.length > itensPorPagina && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 18 }}>
            <button
              onClick={() => setPagina(p => Math.max(1, p - 1))}
              disabled={pagina === 1}
              style={{ padding: '6px 16px', borderRadius: 5, border: '1px solid #bdbdbd', background: pagina === 1 ? '#eee' : '#3d8c5e', color: pagina === 1 ? '#888' : '#fff', fontWeight: 600, cursor: pagina === 1 ? 'not-allowed' : 'pointer', fontSize: 15 }}
            >
              Anterior
            </button>
            <span style={{ fontWeight: 600, fontSize: 15, color: '#3d3d3d' }}>Página {pagina} de {totalPaginas}</span>
            <button
              onClick={() => setPagina(p => Math.min(totalPaginas, p + 1))}
              disabled={pagina === totalPaginas}
              style={{ padding: '6px 16px', borderRadius: 5, border: '1px solid #bdbdbd', background: pagina === totalPaginas ? '#eee' : '#3d8c5e', color: pagina === totalPaginas ? '#888' : '#fff', fontWeight: 600, cursor: pagina === totalPaginas ? 'not-allowed' : 'pointer', fontSize: 15 }}
            >
              Próxima
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
